import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { TeamFragmentDoc } from './team';
export type TeamWithUsersFragment = { __typename?: 'Team', id: number, label: string, constantName: string, region: Types.RegionEnum, teamType?: string | null, users: Array<{ __typename?: 'TeamMembership', id: number, membershipType: Types.MembershipTypeEnum, teamId: string, user: { __typename?: 'User', id: number, name: string, imageUrl?: string | null } }>, recursiveParents: Array<{ __typename?: 'Team', id: number, constantName: string, label: string }>, parentTeam?: { __typename?: 'Team', id: number, constantName: string, label: string } | null };

export const TeamWithUsersFragmentDoc = gql`
    fragment teamWithUsers on Team {
  ...team
  users {
    id
    membershipType
    teamId
    user {
      id
      name
      imageUrl
    }
  }
}
    ${TeamFragmentDoc}`;